export default "__VITE_ASSET__$OQIhrf4__"